import React, { useContext } from 'react';
import { RendererContext } from '../../context';
// eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
import { Text } from '@atlaskit/primitives';
import SectionMessage from '@atlaskit/section-message';
import Link from '@atlaskit/link';

type EgressErrorMessageProps = {
	url: string;
};

export const EgressErrorMessage = ({ url }: EgressErrorMessageProps): React.JSX.Element => {
	const { forgeEnvironment } = useContext(RendererContext);
	const dataUriRegex = /^data/;
	const isDataUri = dataUriRegex.test(url);

	if (forgeEnvironment === 'DEVELOPMENT') {
		return (
			<SectionMessage appearance="error" testId="egress-error-message">
				{isDataUri ? (
					// eslint-disable-next-line @atlassian/i18n/no-literal-string-in-jsx
					<Text>
						Please use the {/* eslint-disable-next-line @atlassian/i18n/no-literal-string-in-jsx */}
						<Text as="strong">data:image</Text> scheme for an image source.
					</Text>
				) : (
					// eslint-disable-next-line @atlassian/i18n/no-literal-string-in-jsx
					<Text>
						Egress permissions for{' '}
						<Link href={url} target="_blank">
							{url}
							{/* eslint-disable-next-line @atlassian/i18n/no-literal-string-in-jsx */}
						</Link>{' '}
						missing in the manifest. For more information{' '}
						<Link
							href="https://developer.atlassian.com/platform/forge/manifest-reference/permissions/#images"
							target="_blank"
							// eslint-disable-next-line @atlassian/i18n/no-literal-string-in-jsx
						>
							see reference docs
						</Link>
						.
					</Text>
				)}
			</SectionMessage>
		);
	}

	return (
		// eslint-disable-next-line @atlassian/i18n/no-literal-string-in-jsx
		<SectionMessage appearance="error">
			Unable to display due to an image link issue.
		</SectionMessage>
	);
};
